import { css } from '@emotion/react';
import { p2r } from '../../styles/fonts';
import { ARTICLE_SIDE_INDENT } from '../../styles/vars';
import { breakpoints } from '../../styles';

const initialMargins = { top: 0, right: 0, bottom: 0, left: 0 };

const styles = ({
  width,
  height,
  backgroundColor = 'none',
  alignFirstColumnFlexContainer = { alignItems: 'flex-start', justifyContent: 'flex-start' },
  marginFirstColumn: first = initialMargins,
  marginSecondColumn: second = initialMargins,
}) => css`
  .strong-word-section__container {
    position: relative;
    display: grid;
    grid-template-areas:
      'title posts'
      'last-post last-post';
    grid-template-columns: 50% 50%;
    grid-row-gap: 12px;
    width: 100%;
    max-width: ${width};
    min-height: ${p2r(height)};
    padding-top: ${p2r(second.top)};
    background-color: ${backgroundColor};
  }

  .strong-word-section__text-container {
    width: 100%;
    max-width: 400px;
  }

  .strong-word-section__column-first {
    display: flex;
    flex-direction: column;
    grid-area: title;
    align-items: ${alignFirstColumnFlexContainer.alignItems};
    justify-content: ${alignFirstColumnFlexContainer.justifyContent};
    margin: ${p2r(first.top)} ${first.right}px ${p2r(first.bottom)} ${first.left}px;
    line-height: 110%;
    letter-spacing: ${p2r(-3.9)};
  }

  .strong-word-section__column-second {
    grid-area: posts;
    margin: 0 ${second.right}px ${p2r(second.bottom)};
  }

  .strong-word-section__merge-columns-block {
    grid-area: last-post;
    margin: 0 auto;
  }

  .strong-word-section__navigation-link {
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .strong-word-section__column-first,
    .strong-word-section__column-second {
      margin: 0;
    }

    .strong-word-section__column-first {
      align-items: center;
      justify-content: center;
    }

    .strong-word-section__column-second {
      padding: ${p2r(32)};
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .strong-word-section__container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      max-width: 100%;
      padding: 0 ${ARTICLE_SIDE_INDENT};
    }

    .strong-word-section__column-first {
      align-items: flex-start;
    }

    .strong-word-section__column-second {
      margin: 0 auto;
    }

    .strong-word-section__column-first,
    .strong-word-section__column-second {
      padding: 0;
      padding-bottom: ${p2r(32)};
    }

    .strong-word-section__text-container {
      max-width: 100%;
    }
  }
`;

export default styles;
